import React, { useEffect, useMemo, useState } from "react";
import AdminUserService from "../../../services/adminUserServices";
import { Column, useSortBy, useTable } from "react-table";
import { useForm } from "react-hook-form";
import ButtonWithIcon from "../../../components/StyledComp/ButtonWithIcon";
import ReactModal from "react-modal";
import {
  Button,
  Label,
  PageLink,
} from "../../../components/StyledComp/StyledComp";
import "../../../Styles/CommonStyles.scss";
import EditIcon from "@mui/icons-material/Edit";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useAppSelector } from "../../../store/hooks";

interface AddFormValue {
  MemberTag: string | null;
  Description: string | null;
  Fee: number | null;
  Status: string | null;
}

const MemberTag: React.FC = () => {
  const [memberTag, setMemberTag] = useState<any[] | undefined>([]);
  const [dialogTitle, setdialogTitle] = useState<string>("Add Member Tag");

  // const [MemberTagInput, setMemberTagInput] = useState<string | undefined>();
  // const [Description, setDescription] = useState<string | undefined>();
  // const [Fee, setFee] = useState<number | undefined>();
  // const [Status, setStatus] = useState<number>(1);

  const [addTagOpen, setaddTagOpen] = useState<boolean>(false);
  const [Id, setId] = useState<number>(1);
  const [selectedRow, setSelectedRow] = useState<any | undefined>();
  const [isEdit, setisEdit] = useState<boolean>(false);
  const form = useForm<AddFormValue>();
  const { register, control, handleSubmit, formState, setValue, reset } = form;
  const { errors, touchedFields, dirtyFields } = formState;
  const roleCapabilites = useAppSelector(
    (state) => state.user.roleCapabilities
  );

  const getMemberTag = async () => {
    const response = await AdminUserService.getMemberTag();
    console.log(response);
    if (response.data.data != null) {
      setMemberTag(response.data.data);
    } else {
      alert(response.data.errors[0]);
    }
  };
  useEffect(() => {
    getMemberTag();

    // getMemberTag();
  }, []);

  const addMemberTag = async (data: any) => {
    const response = await AdminUserService.addMemberTag(data);
    console.log(response);
    if (response.data.data != null) {
      // setMemberTag(response.data.data);
      getMemberTag();
      setaddTagOpen(false);
      alert("Member Tag Added Successfully");
    } else {
      alert(response.data.errors[0]);
    }
  };

  const updateMemberTag = async (data: any) => {
    const response = await AdminUserService.updateMemberTag(data);
    console.log(response);
    if (response.data.data != null) {
      // setMemberTag(response.data.data);
      getMemberTag();
      setaddTagOpen(false);
      alert("Member Tag Updated Successfully");
    } else {
      alert(response.data.errors[0]);
    }
  };

  const columns = React.useMemo<Column<any>[]>(
    () => [
      { id: "Id", Header: "ID", accessor: "Id" },
      { id: "MemberTag", Header: "MemberTag", accessor: "MemberTag" },
      { id: "Description", Header: "Description", accessor: "Description" },
      { id: "Fee", Header: "Fee", accessor: "Fee" },
      {
        id: "Status",
        Header: "Status ID",
        accessor: "Status",
        Cell: ({ value }: { value: number }) => (
          <span>{value === 1 ? "Active" : "Inactive"}</span>
        ),
      },
      {
        id: "edit",
        Header: "Action",
        accessor: (row: any) => (
          <a
            className="d-flex editRow justify-content-center"
            onClick={() => handleEdit(row)}
          >
            <EditIcon></EditIcon>
          </a>
        ),
        // width: "100px"
      },
    ],
    []
  );

  const handleEdit = (rowData: any) => {
    if (
      !roleCapabilites.some((obj: any) =>
        Object.values(obj).includes("settings.edit")
      )
    ) {
      alert("No Access");
      return;
    }
    console.log("Edit clicked for row:", rowData);
    setisEdit(true);
    reset();
    setSelectedRow(rowData);
    // setState({
    //     data: {
    //         MemberTag: rowData.MemberTag,
    //         Description: rowData.SectionDescription,
    //         Fee: rowData.Fee,
    //         Status: rowData.Status
    //     }
    // })
    setValue("MemberTag", rowData.MemberTag);
    setValue("Description", rowData.Description);
    setValue("Fee", rowData.Fee);
    setValue("Status", rowData.Status);

    // setMemberTagInput(rowData.MemberTag);
    // setDescription(rowData.Description);
    // setFee(rowData.Fee);
    // setStatus(rowData.Status);
    setId(rowData.Id);
    setdialogTitle("Update Member Tag");
    setaddTagOpen(true);
  };

  const data = useMemo(() => memberTag, [memberTag])!;

  const TableInstance = useTable(
    {
      columns,
      data,
    },
    useSortBy
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    TableInstance;
  let index = 0;

  const onSubmit = (data: AddFormValue) => {
    const MemberTag = data.MemberTag || "";
    const Description = data.Description || "";
    const status = data.Status !== undefined ? data.Status : "";
    const Fee = data.Fee !== undefined ? data.Fee : "";

    // let data = {
    //     'MemberTag': MemberSectionInput,
    //     'Description': Description,
    //     'Fee': Fee,
    //     'Status': Status
    // }
    const formData = {
      MemberTag: MemberTag,
      Description: Description,
      Status: status,
      Fee: Fee,
    };
    let id = {
      Id: Id,
    };
    console.log("SUBMIT");
    // console.log(e)
    console.log(data);
    console.log(formData);
    isEdit ? updateMemberTag({ ...formData, ...id }) : addMemberTag(formData);
  };

  // const updateInput = (event: any): void => {
  //     console.log(event.target.name, event.target.value)
  //     // switch (event.target.name) {
  //     //     case "MemberTag":
  //     //         setMemberTagInput(event.target.value);
  //     //         console.log(MemberTagInput)
  //     //         break;
  //     //     case "Description":
  //     //         setDescription(event.target.value)
  //     //         break;
  //     //     case "Fee":
  //     //         setFee(parseInt(event.target.value))
  //     //         break;
  //     //     default:
  //     //         break;
  //     // }
  //     setState({
  //         data: {
  //             ...state.data,
  //             [event.target.name]: event.target.value,
  //         },
  //     });
  // };

  // const updateStatus = (event: React.ChangeEvent<HTMLSelectElement>): void => {
  //     console.log(event.target.name, event.target.value)
  //     setStatus(parseInt(event.target.value))

  // };

  const openDialog = () => {
    if (
      !roleCapabilites.some((obj: any) =>
        Object.values(obj).includes("settings.create")
      )
    ) {
      alert("No Access");
      return;
    }
    setisEdit(false);
    // setMemberTagInput('');
    // setDescription('');
    // setFee(undefined);
    // setStatus(1);
    // setValue('MemberTag', '')
    // reset()
    setValue("MemberTag", "");
    setValue("Description", "");
    setValue("Fee", 0);
    setValue("Status", "1");
    setdialogTitle("Add Member Tag");
    setaddTagOpen(true);
  };

  const handleClose = () => {
    reset();
    setaddTagOpen(false);
  };
  return (
    <div className="container-fluid">
      <div className="dashboard-content-wrapper">
        <div
          className="d-flex justify-content-between"
          style={{ width: "90%" }}
        >
          <h1 className="page-heading">Member Tag</h1>
          <div className="settings-add-button ms-4">
            <div className="secondary-button" onClick={() => openDialog()}>
              <AddCircleOutlineIcon></AddCircleOutlineIcon>
              <span className="ps-1">Add Member Tag</span>
            </div>
            {/* <ButtonWithIcon
                            icon={<></>}
                            buttontext="Add Member Tag"
                            onClick={() => openDialog()}
                        /> */}
          </div>
        </div>
        <div className="memberTag-table">
          <table {...getTableProps}>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps} key={index++}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()} key={column.id}>
                      {column.render("Header")}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps}>
              {rows.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()} key={row.index}>
                    {row.cells.map((cell) => {
                      return (
                        <td {...cell.getCellProps()}> {cell.render("Cell")}</td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <ReactModal
        isOpen={addTagOpen}
        className="addtype-modal"
        overlayClassName="overlay"
      >
        <div
          className="horizontal-wrapper-spacebetween"
          style={{ marginBottom: "1rem", zIndex: "20", height: "5%" }}
        >
          <h1
            className="page-heading"
            // style={{ marginBottom: "2rem", }}
          >
            {dialogTitle}
          </h1>
          <PageLink
            onClick={() => handleClose()}
            style={{ marginBottom: "1rem" }}
          >
            Cancel
          </PageLink>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="d-flex">
            <div className="input-field-div-wrapper w-100">
              <Label>Member Tag</Label>
              <input
                className="input-field-div"
                placeholder="Member Tag"
                {...register("MemberTag", {
                  required: "Member Tag is required",
                })}
                name="MemberTag"
                id="MemberTag"
                autoComplete="off"
              />
              <p className="form-error form-error-position">
                {errors.MemberTag?.message}
              </p>
            </div>
            <div className="input-field-div-wrapper w-100 mx-3">
              <Label>Description</Label>
              <input
                className="input-field-div"
                placeholder="Description"
                {...register("Description", { required: false })}
                name="Description"
                id="Description"
                autoComplete="off"
              />
              {/* <p className="form-error form-error-position">
                                {errors.Description?.message}
                            </p> */}
            </div>
            <div className="input-field-div-wrapper w-100">
              <Label>Fee</Label>
              <input
                className="input-field-div"
                placeholder="Fee"
                {...register("Fee", { required: false })}
                name="Fee"
                id="Fee"
                autoComplete="off"
              />
              {/* <p className="form-error form-error-position">
                                {errors.Fee?.message}
                            </p> */}
            </div>
          </div>

          <div className="d-flex">
            <select
              style={{ marginTop: "6px" }}
              className="dropdown-control-large"
              {...register("Status", { required: false })}
              name="Status"
              id="Status"
            >
              <option value="1">Active</option>
              <option value="0">Inactive</option>
            </select>
            {/* <p className="form-error form-error-position">
                            {errors.Status?.message}
                        </p> */}
          </div>
          <div className="w-100 d-flex justify-content-center">
            <div className="submit-button-div">
              <Button type="submit">{isEdit ? "Update" : "Add"}</Button>
            </div>
          </div>
        </form>
      </ReactModal>
    </div>
  );
};

export default MemberTag;
